<div
  class="impact"
  [class.impact--empty]="!hasContent"
  [class.impact--reserve]="reserveHeight()">
  @if (isGlobalInfluence || visibleCountries.length > 0 || visibleRegions.length > 0) {
    <div class="impact-area">
      <span class="impact-heading">{{ 'charity_catalog.card.impact_area' | translateLang }}</span>
      <div class="impact-rows">
        @if (isGlobalInfluence || visibleCountries.length > 0) {
          <div class="impact-row">
            <span class="impact-row-label">{{ 'charity_catalog.card.country' | translateLang }}</span>
            @if (isGlobalInfluence) {
              <span class="impact-row-values">
                <span class="impact-row-text">{{ 'charity_catalog.card.global' | translateLang }}</span>
              </span>
            } @else {
              <span
                class="impact-row-values"
                [class.impact-row-values--expanded]="countriesExpanded"
                #countriesContainer>
                <span class="impact-row-text">{{ visibleCountries.join(', ') }}</span>
                @if (countriesHasOverflow) {
                  <span
                    class="impact-more"
                    role="button"
                    tabindex="0"
                    (click)="onMore($event)"
                    (keydown.enter)="onMore($event)"
                    (keydown.space)="onMore($event)">
                    {{ 'charity_catalog.card.more' | translateLang: { count: countriesOverflowCount } }}
                  </span>
                }
              </span>
            }
          </div>
        }
        @if (isGlobalInfluence || visibleRegions.length > 0) {
          <div class="impact-row">
            <span class="impact-row-label">{{ 'charity_catalog.card.region' | translateLang }}</span>
            @if (isGlobalInfluence) {
              <span class="impact-row-values">
                <span class="impact-row-text">{{ 'charity_catalog.card.global' | translateLang }}</span>
              </span>
            } @else {
              <span
                class="impact-row-values"
                [class.impact-row-values--expanded]="regionsExpanded"
                #regionsContainer>
                <span class="impact-row-text">{{ visibleRegions.join(', ') }}</span>
                @if (regionsHasOverflow) {
                  <span
                    class="impact-more"
                    role="button"
                    tabindex="0"
                    (click)="onMore($event)"
                    (keydown.enter)="onMore($event)"
                    (keydown.space)="onMore($event)">
                    {{ 'charity_catalog.card.more' | translateLang: { count: regionsOverflowCount } }}
                  </span>
                }
              </span>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (focusAreas().length > 0) {
    <div class="focus">
      <span class="impact-heading">{{ 'charity_catalog.card.focus_areas' | translateLang }}</span>
      <div
        class="focus-pills"
        [class.focus-pills--expanded]="focusAreasExpanded"
        #focusAreasContainer>
        @for (area of visibleFocusAreas; track area) {
          <span class="focus-pill" [title]="area">
            <span class="focus-pill-text">{{ area }}</span>
          </span>
        }
        @if (focusHasOverflow) {
          <span
            class="impact-more"
            role="button"
            tabindex="0"
            (click)="onMore($event)"
            (keydown.enter)="onMore($event)"
            (keydown.space)="onMore($event)">
            {{ 'charity_catalog.card.more' | translateLang: { count: focusOverflowCount } }}
          </span>
        }
      </div>
    </div>
  }
</div>
